module.exports = __webpack_public_path__ + "static/media/asenso_logo.f44f1f8d.svg";